import type { ApiConfig, FetchApiData, FetchSubTypes } from '../types'
import { perpsFundingHistoryApiConfig } from './perpsFundingHistory/constants'
import { fetchApiData as fetchPerpsFundingHistoryApiData } from './perpsFundingHistory/fetchApiData'
import { perpsTradeHistoryApiConfig } from './perpsTradeHistory/constants'
import { fetchApiData as fetchPerpsTradeHistoryApiData } from './perpsTradeHistory/fetchApiData'
import { spotTradeHistoryApiConfig } from './spotTradeHistory/constants'
import { fetchApiData as fetchSpotTradeHistoryApiData } from './spotTradeHistory/fetchApiData'

export const sodexApiConfigs = {
  [perpsFundingHistoryApiConfig.type]: perpsFundingHistoryApiConfig,
  [perpsTradeHistoryApiConfig.type]: perpsTradeHistoryApiConfig,
  [spotTradeHistoryApiConfig.type]: spotTradeHistoryApiConfig,
} as const satisfies Record<string, ApiConfig>

export type SodexApiType = keyof typeof sodexApiConfigs

export const sodexApiTypes = Object.keys(sodexApiConfigs) as SodexApiType[]

export const fetchSodexApiDataFuncs = {
  [perpsFundingHistoryApiConfig.type]: fetchPerpsFundingHistoryApiData,
  [perpsTradeHistoryApiConfig.type]: fetchPerpsTradeHistoryApiData,
  [spotTradeHistoryApiConfig.type]: fetchSpotTradeHistoryApiData,
} as const satisfies Record<string, FetchApiData>

export const fetchSodexSubTypesFuncs = {
  [perpsFundingHistoryApiConfig.type]: undefined,
  [perpsTradeHistoryApiConfig.type]: undefined,
  [spotTradeHistoryApiConfig.type]: undefined,
} as const satisfies Record<string, FetchSubTypes | undefined>

export { getCurrentSodexAssets } from './getCurrentAsset'
